import { useUser } from "../../context/UserContext";
import { Flex } from "@chakra-ui/react";
import { useEffect } from "react";
import Header from "../Header";
import Router from "../Router";
import StagingWarningBanner from "../StagingWarningBanner";
import Footer from "../Footer";

function App() {
  const { logoutFn } = useUser();

  useEffect(() => {
    const isProduction = import.meta.env.VITE_NODE_ENV === "testnet-sepolia";
    const baseTitle = "EarthFast Dashboard";
    const title = isProduction ? baseTitle : `${baseTitle} [Staging]`;
    document.title = title;
  }, []);

  return (
    <Flex direction="column" minHeight="100vh">
      <StagingWarningBanner />
      <Header logoutFn={logoutFn} />
      <Flex flex="1" width="100%">
        <Router />
      </Flex>
      <Footer />
    </Flex>
  );
}

export default App;
